import { createLogger } from '@/lib/logger';

const log = createLogger('DEBUG');

interface PasswordResetAttempt {
  email: string;
  redirectTo: string;
  success: boolean;
  error?: {
    message: string;
    status?: number;
    code?: string;
  };
  timestamp: number;
}

interface DeepLinkState {
  lastDeepLink: string | null;
  lastParsedParams: Record<string, any> | null;
  lastAuthEvent: string | null;
  timestamp: number | null;
  lastPasswordResetAttempt: PasswordResetAttempt | null;
}

let state: DeepLinkState = {
  lastDeepLink: null,
  lastParsedParams: null,
  lastAuthEvent: null,
  timestamp: null,
  lastPasswordResetAttempt: null,
};

const listeners: ((state: DeepLinkState) => void)[] = [];

export const debugStore = {
  getState: () => state,

  setDeepLink: (url: string, parsedParams: Record<string, any>) => {
    state = {
      ...state,
      lastDeepLink: url,
      lastParsedParams: parsedParams,
      timestamp: Date.now(),
    };
    listeners.forEach(listener => listener(state));
    log.info('[DEBUG_STORE] Deep link recorded:', { url, parsedParams });
  },

  setAuthEvent: (event: string) => {
    state = {
      ...state,
      lastAuthEvent: event,
      timestamp: Date.now(),
    };
    listeners.forEach(listener => listener(state));
    log.info('[DEBUG_STORE] Auth event recorded:', event);
  },

  setPasswordResetAttempt: (attempt: PasswordResetAttempt) => {
    state = {
      ...state,
      lastPasswordResetAttempt: attempt,
    };
    listeners.forEach(listener => listener(state));
    log.info('[DEBUG_STORE] Password reset attempt recorded:', attempt);
  },

  subscribe: (listener: (state: DeepLinkState) => void) => {
    listeners.push(listener);
    return () => {
      const index = listeners.indexOf(listener);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  },

  clear: () => {
    state = {
      lastDeepLink: null,
      lastParsedParams: null,
      lastAuthEvent: null,
      timestamp: null,
      lastPasswordResetAttempt: null,
    };
    listeners.forEach(listener => listener(state));
  },
};
